import { render, staticRenderFns } from "./OutfitDetail.vue?vue&type=template&id=3330eaeb&"
import script from "./OutfitDetail.vue?vue&type=script&lang=js&"
export * from "./OutfitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports